import type { Hono } from 'hono';
import { hc } from 'hono/client';
import type { AppType } from '../../../backend/src/index';

// Extract Hono-compatible type from OpenAPIHono
type HonoClient = AppType extends Hono<infer Env, infer Schema, infer BasePath> ? Hono<Env, Schema, BasePath> : Hono;

// Hono client type
const client = hc<HonoClient>('/');

export { client };
export type { AppType };
